import React, {useContext, useEffect, useState, useRef} from 'react';
import { useNavigate } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';
import { useReactToPrint } from 'react-to-print';
import RteNotificaciones from '../components/reportes/RteNotificaciones';
import RteUsuariosPorRol from '../components/reportes/RteUsuariosPorRol';

const Admin = () => {
  const printComponentRef = useRef();

  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [logs, setLogs] = useState([])
  const [header, setHeader] = useState([]);
  const [reporte, setReporte] = useState({tag: null, nombre: null, items: []});
  const [query, setQuery] = useState({
    query: ""
  });

  const reportes = {
    rteNotificaciones: RteNotificaciones,
    rteUsuariosPorRol: RteUsuariosPorRol,
  };

    const handlePrint = useReactToPrint({
        content: () => printComponentRef.current,
    });

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && authInformation.rol === 'Admin'){
      setRenderHTML(true)
      fetchLogs()
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const fetchLogs = async (sortBy='', q='', page=1, otro='') => {
    try {
      const data = await resourcesServices.obtenerResources('logs', sortBy, q, page, otro);

      if (page === 1) {
        setLogs(data.data);
      } else {
        setLogs([...logs, ...data.data]);
      }

      setHeader(data.headers);

    } catch (error) {
      errorMessage(error)
    }
  };

  const descargarBackup = async () => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('usuarios', 'ejecutarBackup');
      const aTag = document.createElement("a");
      aTag.href = data.url
      aTag.setAttribute("download", data.filename)
      document.body.appendChild(aTag)
      aTag.click();
      aTag.remove();

    } catch (error) {
      errorMessage(error)
    }
  };

  const reporteDeUsuarios = async () => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('reportes', 'usuarios_por_rol');

      setReporte({tag: 'rteUsuariosPorRol', nombre: "Usuarios por Roles", items: data})

    } catch (error) {
      errorMessage(error)
    }
  };

  const reporteDeNotificaciones = async () => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('reportes', 'notificaciones');

      setReporte({tag: 'rteNotificaciones', nombre: "Notificaciones", items: data})

    } catch (error) {
      errorMessage(error)
    }
  };

  const obtenerPagina = async (page=1) => {
    fetchLogs('', query, page, '')
  };

  const handleFormSubmit = (e) => {
    e.preventDefault()

    fetchLogs('', query, 1, '')
  }

  return (
    <div>
      <h1>Admin <BotonVolver /></h1>
      {renderHTML && (
        <>

        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button className="nav-link active" id="tab-1" data-bs-toggle="tab" data-bs-target="#tab-pane-1" type="button" role="tab" aria-selected="true">
              Logs
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="tab-2" data-bs-toggle="tab" data-bs-target="#tab-pane-2" type="button" role="tab" aria-selected="true">
              Backups
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button className="nav-link" id="tab-3" data-bs-toggle="tab" data-bs-target="#tab-pane-3" type="button" role="tab" aria-selected="true">
              Reportes
            </button>
          </li>
        </ul>

        <div className="tab-content" id="myTabContent">
          <div className="tab-pane fade show active" id="tab-pane-1" role="tabpanel" aria-labelledby="tab-1" tabIndex="0">
            <h1>Logs</h1>
            <div className="card">
              <div className="card-body px-0 pb-2">
                <div className="table-responsive">
                  <table className="table align-items-center mb-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Accion</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                        <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs && logs.map((log, index) => {
                        return (
                          <tr key={index}>
                            <td>{log.accion}</td>
                            <td className="align-middle text-center text-sm">{log.usuario && (log.usuario.nombre + ' ' + log.usuario.apellido)} ({log.usuario && log.usuario.rol})</td>
                            <td>
                              {log.fecha_alta}
                            </td>
                          </tr>
                        )
                      })
                      }
                    </tbody>
                  </table>

                  {
                    header["total-pages"] !== header["current-page"] && (
                      <div className='p-3'>
                        <button onClick={()=>obtenerPagina(header["current-page"] + 1)} className='btn btn-success mt-3'>Ver más | {header["current-page"]} de {header["total-pages"]}</button>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>

          </div>

          <div className="tab-pane fade" id="tab-pane-2" role="tabpanel" aria-labelledby="tab-2" tabIndex="0">
            <h1>Backups</h1>

            <button type='button' onClick={()=>descargarBackup()} className='btn btn-success mt-3'>Descargar Backup</button>
          </div>

          <div className="tab-pane fade" id="tab-pane-3" role="tabpanel" aria-labelledby="tab-3" tabIndex="0">
            <h1>Reportes</h1>

            <button type='button' onClick={()=>reporteDeUsuarios()} className='btn btn-success'>Usuarios por Rol</button>
            <button type='button' onClick={()=>reporteDeNotificaciones()} className='btn btn-success ms-1'>Notificaciones</button>

            {
              reporte.tag && (
                <>
                  <button type="button" onClick={()=>handlePrint()} className="btn btn-primary ms-3">Imprimir</button>
                  
                  <div className='p-3' ref={printComponentRef}>
                  {(() => {
                    const ModalComponent = reportes[reporte.tag];
                    return <ModalComponent nombre={reporte.nombre} items={reporte.items} />;
                  })()}
                  </div>
                </>
              )
            }
          </div>
        </div>
        </>
      )}
    </div>
  );
};

export default Admin;